import React from 'react';
import './modal_acc_creation_status.styles.scss';
// import { createStructuredSelector } from 'reselect';
// import { connect } from 'react-redux';
// import { selectMessageType } from '../../redux/message/message.selector';

const AccCreationStatusModal = (props) => {
  const { data } = props;

  return (
    <div className="message_status_container">
      {data.map((record, i) => {
        return (
          <div key={i} className="record-container">
            <div className="name">{`${record.acc}`}</div>
            <div className="type">{record.type}</div>
            {record.status && <div className="status">{record.message}</div>}
            {!record.status && (
              <div className="status-failed">{record.message}</div>
            )}
          </div>
        );
      })}
    </div>
  );
};

// const mapStateToProps = createStructuredSelector({
//   messageType: selectMessageType,
// });

export default AccCreationStatusModal;
